module.exports = __webpack_public_path__ + "img/connectplug-logo-azul.01ab9b9e.png";